import React, { useState } from 'react';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import NewReplyContainer from '@nile/banyan/src/Containers/CascadeContainers/NewReplyContainer';
import { TEMPLATE_TYPES } from '@nile/banyan/src/Constants/notifications';
import { Modal } from '@superops/ui-design-system';

const DEFAULT_CONTENT = `<p style="scrollbar-width: auto; margin: 0px; font-size: 1em; font-weight: 400; box-sizing: border-box;" id="isPasted">Hi <span class="fr-deletable fr-tribute mention" data-value="Client name" data-id="entityAttribute.client.name" data-denotation-char="#" contenteditable="false"><span class="ql-mention-denotation-char">#</span>Client name</span>&nbsp; &nbsp; &nbsp;</p><p style="scrollbar-width: auto; margin: 0px; font-size: 1em; font-weight: 400; box-sizing: border-box;"><br style="scrollbar-width: auto; box-sizing: border-box;"></p><p style="scrollbar-width: auto; margin: 0px; font-size: 1em; font-weight: 400; box-sizing: border-box;">This is a friendly reminder that invoice <span class="fr-deletable fr-tribute mention" data-value="Invoice ID" data-id="attribute.invoiceId" data-denotation-char="#" contenteditable="false"><span class="ql-mention-denotation-char">#</span>Invoice ID</span>&nbsp; for <span class="fr-deletable fr-tribute mention" data-value="Amount Due" data-id="attribute.amountDue" data-denotation-char="#" contenteditable="false"><span class="ql-mention-denotation-char">#</span>Amount Due</span>&nbsp; &nbsp;is due on <span class="fr-deletable fr-tribute mention" data-value="Due Date" data-id="attribute.dueDate" data-denotation-char="#" contenteditable="false"><span class="ql-mention-denotation-char">#</span>Due Date</span>&nbsp; &nbsp; &nbsp;</p><p style="scrollbar-width: auto; margin: 0px; font-size: 1em; font-weight: 400; box-sizing: border-box;"><br style="scrollbar-width: auto; box-sizing: border-box;"></p><p style="scrollbar-width: auto; margin: 0px; font-size: 1em; font-weight: 400; box-sizing: border-box;"><span style="white-space: pre-wrap; scrollbar-width: auto; box-sizing: border-box;">Kindly make the payment at your earliest convenience.<br style="scrollbar-width: auto; box-sizing: border-box;">Thanks for your prompt attention.</span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>`;

const DEFAULT_SUBJECT = 'Invoice #Invoice ID Invoice is due soon';

const DEFAULT_PLACEHOLDERS_USED = JSON.stringify({
  content: {
    'entityAttribute.client.name': 'Client name',
    'attribute.invoiceId': 'Invoice ID',
    'attribute.amountDue': 'Amount Due',
    'attribute.dueDate': 'Due Date'
  },
  subject: { 'attribute.invoiceId': 'Invoice ID' }
});

export type TemplateShape = {
  activated?: boolean;
  attachmentList?: any[];
  subject?: string;
  name?: string;
  content?: string;
  placeholdersUsed?: string;
  templateType?: string;
  to?: any[];
  bcc?: any[];
  cc?: any[];
  id?: string | null;
  templateSubtype?: string;
  canConfigureTo?: boolean;
  canConfigureCcAndBcc?: boolean;
};

export function getDefaultTemplate(
  initialTemplate?: TemplateShape
): TemplateShape {
  return {
    activated: initialTemplate?.activated ?? true,
    attachmentList: initialTemplate?.attachmentList ?? [],
    subject: initialTemplate?.subject ?? DEFAULT_SUBJECT,
    name: initialTemplate?.name ?? '',
    content: initialTemplate?.content
      ? dompurifier(initialTemplate?.content)
      : dompurifier(DEFAULT_CONTENT),
    placeholdersUsed:
      initialTemplate?.placeholdersUsed ?? DEFAULT_PLACEHOLDERS_USED,
    templateType: initialTemplate?.templateType ?? 'INVOICE',
    to: initialTemplate?.to ?? [
      {
        type: 'PLACEHOLDER',
        placeHolder: 'placeholder.client.primaryContact'
      }
    ],
    bcc: initialTemplate?.bcc ?? [],
    cc: initialTemplate?.cc ?? [],
    id: initialTemplate?.id ?? null,
    templateSubtype: initialTemplate?.templateSubtype || 'USER',
    canConfigureTo: initialTemplate?.canConfigureTo || true,
    canConfigureCcAndBcc: initialTemplate?.canConfigureCcAndBcc || true
  };
}

export const InvoiceSettingsTemplate = ({
  template: initialTemplate = {} as TemplateShape,
  onCancel,
  onSuccess
}: {
  template: TemplateShape;
  onCancel: () => void;
  onSuccess: (template: TemplateShape) => void;
}) => {
  const [template] = useState<TemplateShape>(() => {
    return getDefaultTemplate(initialTemplate);
  });

  return (
    <Modal
      open
      onClose={onCancel}
      large
      showCloseButton={false}
      // title="Invoice Template"
    >
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {((NewReplyContainer as unknown) as any) && (
        <NewReplyContainer
          // @ts-ignore - library component expects injected intl in some usages
          onCancel={onCancel}
          // @ts-ignore
          onSuccess={onSuccess}
          // @ts-ignore
          template={template}
          // @ts-ignore
          isPopup={false}
          // @ts-ignore
          type={TEMPLATE_TYPES.invoice}
          // @ts-ignore
          noPadding
        />
      )}
    </Modal>
  );
};
